let isGridLoading = false;
document.querySelector(".ts-blog__more-button").addEventListener("click", (e) => {
  const gridContainer = e.target.closest(".ts-blog").querySelector("#TSPostsGrid");
  const pages = parseInt(gridContainer.dataset.pages);
  const current = parseInt(gridContainer.dataset.current);

  if (pages !== current && !isGridLoading) {
    isGridLoading = true;
    fetch(`${window.location.origin + window.location.pathname}?page=${current + 1}`)
    .then(response => response.text())
    .then(text => {
      const html = new DOMParser().parseFromString(text, "text/html");
      const newArticles = html.querySelectorAll("#TSPostsGrid > div");
      newArticles.forEach(newArticle => {
        gridContainer.append(newArticle);
      });
      gridContainer.setAttribute("data-current", current + 1);

      if (current + 1 === pages) {
        e.target.setAttribute("hidden", true);
      } else {
        isGridLoading = false;
      }
    })
    .catch(error => console.error(error))
  }
})